import './app.js'
import { loadScript } from './helpers.js'
import { theme } from '../../tailwind.config.js'

const ratio = 1.88
const mapDiv = document.getElementById( 'map' )
const { colors : { secondary : colorMap } } = theme

/**
 * Resize map
 */
window.addEventListener( 'resize', () => {
  const { clientWidth: width } = mapDiv
  const { innerWidth, innerHeight } = window

  mapDiv.style.height = Math.round( width / ( innerWidth > innerHeight ? ratio : 1 ) ) + 'px'
})
window.dispatchEvent( new Event( 'resize' ) )


/**
 * Init map
 */
function callback()
{
  const myLatLng = {
    lat: 45.127291,
    lng: 7.59103
  }

  const map = new google.maps.Map( mapDiv, {
    zoomControl: true,
    zoomControlOptions: false,
    mapTypeControl: false,
    mapTypeControlOptions: false,
    streetViewControl: false,
    overviewMapControl: false,
    center: myLatLng,
    zoom: 16,
    styles: [
      {"featureType":"all","stylers":[{"saturation":10},{"hue": colorMap }]},
      {"featureType":"road","stylers":[{"saturation":-70}]},
      {"featureType":"water","stylers":[{"visibility":"simplified"},{"saturation":-60}]}
    ]
  })

  const marker = new google.maps.Marker({
    position: myLatLng,
    map: map
  })

}

//delayed load map
setTimeout( () => {
  loadScript( `https://maps.googleapis.com/maps/api/js?v=3&key=${process.env.MIX_G_MAP_KEY}`, { callback } )
}, process.env.MIX_LIB_3RD_DELAY )
